import React from 'react';
import { forwardRef } from '@heroui/system';

interface CustomFormLabelProps extends Omit<React.HTMLAttributes<HTMLElement>, 'as'> {
  isRequired?: boolean;
  className?: string;
  htmlFor?: string;
  as?: 'label' | 'span' | 'legend';
}

const CustomFormLabel = forwardRef<'label' | 'span' | 'legend', CustomFormLabelProps>((props, ref) => {
  const { children, isRequired = false, className = '', htmlFor, as = 'label', ...restProps } = props;

  const Tag = as;
  const labelProps = as === 'label' ? { htmlFor } : {};

  return (
    <Tag ref={ref} className={`text-hs font-semibold font-secondary ${className}`} {...labelProps} {...restProps}>
      {children}
      {isRequired && (
        <span className="text-danger" aria-hidden="true">
          *
        </span>
      )}
      {isRequired && <span className="sr-only">Required</span>}
    </Tag>
  );
});

CustomFormLabel.displayName = 'CustomFormLabel';

export default CustomFormLabel;
